<template>
  <div class="login-form-wrapper">
    <div class="arrow-container-3">
      <a @click="goToBack"
        ><img src="@/assets/timeslot-images/left-arrow.svg"
      /></a>
    </div>
    <div class="div-block-20">
      <div class="div-block login">
        <div class="text-block">Reset Password 🔐</div>
        <div class="text-block-3">
          Enter your email and we will send you a link to reset your password
        </div>
      </div>
      <div class="div-block">
        <FormulateForm>
          <FormulateInput
            type="email"
            placeholder="Email address"
            validation="required"
            validation-name="email"
            v-model="resetModel.username"
          />
        </FormulateForm>

        <div class="div-block-2-copy password"></div>
        <BaseComponentLoader
          v-if="loader.nonBlockingLoader && load"
          loaderAlignment="center"
        />
        <FormulateInput
          type="submit"
          v-else
          label="Proceed"
          @click="newPassword"
        />
      </div>
    </div>
    <div class="text-block-2">© {{ currentYear() }} Timeslate</div>
  </div>
</template>

<script>
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import AuthRequest from "@/model/requests/AuthRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";

export default {
  name: "TimeslotResetPasswordForm",
  components: { BaseComponentLoader },
  data() {
    return {
      resetModel: AuthRequest.initiatePasswordReset,
      initiateModel: AuthRequest.initiateEnrollment,
      load: false
    };
  },

  computed: {
    ...mapState(["loader"]),
    ...mapState({
      userInfo: state => state.auth.userInfo
    })
  },
  methods: {
    newPassword() {
      this.resetModel.countryCode = "234";
      StoreUtils.dispatch(
        StoreUtils.actions.auth.INITIATE_RESET,
        this.resetModel
      ).then(() => {
        this.load = true;
      });
      StoreUtils.commit("auth/setEmail", this.resetModel.username);
    },
    goToBack() {
      RouterUtils.changeRouteUrlTo("/login");
    },
    currentYear() {
      let current_date = new Date();
      let current_year = current_date.getFullYear();
      return current_year;
    }
  }
};
</script>

<style scoped></style>
